import { Coordinates, PRACTICE_SLUG, PracticeSlug } from "models";

// Filtering metadata types
export type EditingRequestCounts = {
  fieldLevel: { open: number; toReview: number; reviewed: number };
  cropLevel: { open: number; toReview: number; reviewed: number };
};

export type PendingPracticeCounts = {
  crops: number;
  fertilizers: number;
  tillageSeeding: number;
};

export type FieldVerification = {
  id: string;
  name: string;
  number: string;
  flik: string;
  location: Coordinates | null;
  size: number;
  regionId: string;
  verifications: {
    id: string;
    verified: boolean | null;
    size: number;
    officialSize: number | null;
    verifiedByAdminUser: string;
    year: number;
  }[];
  commentCount: number;
  redzone: {
    geometry: Coordinates[];
    redzoneId: string;
    year: number;
    confirmed: boolean | null;
    accurate: boolean;
  } | null;
  practiceParticipations: {
    id: string;
    fieldId: string;
    startYear: number;
    practiceSlug: PracticeSlug;
  }[];
  // Filtering metadata for frontend filtering
  editingRequests: EditingRequestCounts;
  pendingPractices: PendingPracticeCounts;
};

export type GetFieldVerificationsResponseBody = {
  fields: FieldVerification[];
};

export const FIELD_VERIFICATION_FILTER = {
  pendingVerification: "pendingVerification",
  pendingCrops: "pendingCrops",
  pendingFertilizers: "pendingFertilizers",
  pendingTillageSeeding: "pendingTillageSeeding",
  crops: PRACTICE_SLUG.CROPS,
  allFields: "allFields",
  // Editing request filters
  hasFieldEditingRequests: "hasFieldEditingRequests",
  hasCropEditingRequests: "hasCropEditingRequests",
  openEditingRequests: "openEditingRequests",
  toReviewEditingRequests: "toReviewEditingRequests",
  reviewedEditingRequests: "reviewedEditingRequests",
} as const;

export type FieldVerificationFilter = (typeof FIELD_VERIFICATION_FILTER)[keyof typeof FIELD_VERIFICATION_FILTER];

export type FieldVerificationSort = {
  sortBy: "name" | "size" | "number";
  sortOrder: "asc" | "desc";
};

export type GetFieldVerificationsQuery = {
  farmId: string;
  search?: string;
  filter?: FieldVerificationFilter;
};
